import { gql } from '@apollo/client'

// mutation name added
export default gql(`
      mutation createVirtualPublishRule($assetId: ID $groupId: ID! $isEnabled: Boolean $startDate: AWSDateTime $endDate: AWSDateTime $project: String $module: String!) {
        createVirtualPublishRule(
            input:{
              assetId: $assetId
              group: $groupId
              isEnabled: $isEnabled
              publishStartDate: $startDate
              publishEndDate: $endDate
              project: $project
            }            
            module: $module
          )
          {
            id
            assetId
            group{
              id
            }
            isEnabled
            publishEndDate
            publishStartDate
          }
      }`
)
